// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import { Carousel,CarouselItem } from 'element-ui';
import ApiRequest from './request/api';
import store from './store';

import zh from '@/components/language/zh'
import en from '@/components/language/en'
Vue.use(VueI18n)
Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.config.productionTip = false
Vue.prototype.$apiRequest = ApiRequest;


//百度统计
var _hmt = _hmt || [];
(function() {
  window._hmt= _hmt
  // console.log('百度统计')
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?9e6983812aef3edd1cef062d64b10071";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

const i18n =new VueI18n({
  locale:localStorage.getItem('language') || 'zh',
  messages:{
    'zh':zh,
    'en':en
  }
  // messages:{
  //   'zh':require('./components/language/zh'),
  //   'en':require('./components/language/en')
  // }
})
//console.log('i18n',i18n)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})
// new Vue({ i18n }).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js